var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvalid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.323 13c0-6.285-5.1-11.323-11.323-11.323-6.285 0-11.323 5.1-11.323 11.323 0 6.285 5.1 11.323 11.323 11.323 6.285 0 11.323-5.1 11.323-11.323zM26 13c0 7.181-5.819 13-13 13S0 20.181 0 13 5.819 0 13 0s13 5.819 13 13zm-19.08.944a.63.63 0 0 1-.63-.63v-.629a.63.63 0 0 1 .63-.629h12.16a.63.63 0 0 1 .63.63v.629a.63.63 0 0 1-.63.629z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalid);
export default __webpack_public_path__ + "static/media/invalid.2a5cc2d255ea3e24cd14cb83c8ade8b6.svg";
export { ForwardRef as ReactComponent };